import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeAttributeCommand extends BaseCommand {
  CommandName = "ChangeAttribute";
  Command: { TmpId: string | null; AttributeTmpId: string; Value: string };
  constructor(sessionId: string, operationId: string, tmpId: string | null, attributeTmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, AttributeTmpId: attributeTmpId, Value: value };
  }
}
